export default __webpack_public_path__ + "static/ogImage-bedf3a0943d434b647b79f3f2d4a6701.png";